import { type FC, useContext, createContext, type ReactNode } from 'react';
import { type PhotoLike } from 'dibs-interiors-photos/exports/usePhotosLikeDataRefetch';

export type PhotoLikesMap = Map<string, PhotoLike & { totalPhotoLikes: number }>;

const PhotoLikesContext = createContext<PhotoLikesMap | null>(null);

type ProviderProps = {
    photoLikesMap: PhotoLikesMap | null;
    children: ReactNode;
};

export const PhotoLikesContextProvider: FC<ProviderProps> = ({ photoLikesMap, children }) => {
    return (
        <PhotoLikesContext.Provider value={photoLikesMap}>{children}</PhotoLikesContext.Provider>
    );
};

export const usePhotoLikesContext = (): PhotoLikesMap | null => useContext(PhotoLikesContext);
